import React, { useEffect } from 'react'
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { logOut_thunk } from '../../../store/slices/auth';
import { MenuOutlined, ProductFilled } from '@ant-design/icons';
import { selectInAppLogoUrl, isFeatureAllowed, selectIsTenantLoading } from '../../../store/slices/tenantSlice';

export default function SideMenu(props: any) {
    // Navigation
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const logoUrl = useSelector(selectInAppLogoUrl);
    const isTenantLoading = useSelector(selectIsTenantLoading);
    // Pre-compute feature checks so menu arrays are stable
    const canSee = useSelector(
        (state: any) => (featureKey: string) => isFeatureAllowed(state, featureKey)
    );

    useEffect(() => {
        const path = window.location.pathname.split('/')[1];
        setCurrentRoute(path);
    }, [window.location.pathname])

    interface MenuItem {
        name: string;
        icon?: string;
        iconComponent?: React.ReactNode;
        path: string;
        /** Matches a feature_name in the tenant config. Undefined = always visible. */
        featureKey?: string;
    }

    const allMenus: MenuItem[] = [
        {
            name: 'Dashboard',
            icon: 'icon icon-dashboard',
            path: 'dashboard',
            featureKey: 'Dashboard'
        },
        {
            name: 'Profile',
            icon: 'icon icon-mentor',
            path: 'profile',
            featureKey: 'Profile'
        },
        {
            name: 'Projects',
            icon: 'icon icon-project',
            path: 'project',
            featureKey: 'Projects'
        },
        {
            name: 'Learning',
            icon: 'icon icon-learning',
            path: 'learning',
            featureKey: 'Learning'
        },
        {
            name: 'Ai Modules',
            iconComponent: <ProductFilled />,
            path: 'ai-module',
            featureKey: 'Ai Modules'
        },
        {
            name: 'Event Invites',
            icon: 'icon icon-topics',
            path: 'submissions',
            featureKey: 'register events'
        },
        {
            name: 'Journal Search',
            icon: 'icon icon-journals',
            path: 'journal',
            featureKey: 'Literature Search'
        },
        {
            name: 'Subscription',
            icon: 'icon icon-subscription',
            path: 'subscriptions',
            featureKey: 'Subscription'
        },
        {
            name: 'Logout',
            icon: 'icon icon-logout',
            path: 'login'
        }
    ];

    const menus = allMenus.filter(m => !m.featureKey || canSee(m.featureKey));

    const allMobileMenus: MenuItem[] = [
        {
            name: 'Profile',
            icon: 'icon icon-mentor',
            path: 'profilemobile',
            featureKey: 'Profile'
        },
        {
            name: 'Projects',
            icon: 'icon icon-project',
            path: 'projectmobile',
            featureKey: 'Projects'
        },
        {
            name: 'Learning',
            icon: 'icon icon-learning',
            path: 'learning',
            featureKey: 'Learning'
        },
        {
            name: 'Event Invites',
            icon: 'icon icon-events',
            path: 'submissions',
            featureKey: 'register events'
        },
        {
            name: 'Logout',
            icon: 'icon icon-logout',
            path: 'login'
        }
    ];

    const mobilemenus = allMobileMenus.filter(m => !m.featureKey || canSee(m.featureKey));

    const [currentRoute, setCurrentRoute] = useState(window.innerWidth > 700 ? 'profile' : 'projectmobile');
    const dispatch = useDispatch();
    const handleroute = (objelm) => {
        if (objelm.path === 'login') {
            dispatch(logOut_thunk() as any);
        } else {
            navigate('/' + objelm.path);
            setCurrentRoute(objelm.path);
        }
        console.log(objelm.path)
    }

    useEffect(() => {
        navigate('/' + currentRoute);

    }, [])
    return (
        <>
            {window.innerWidth > 700 ?

                <div className={isOpen ? 'side-menu' : 'side-menu-close'}>

                    {
                        isOpen ?
                            <div className="menu-logo" >
                                {isTenantLoading || !logoUrl ? (
                                    <div className="logo-skeleton-small" />
                                ) : (
                                    <img src={logoUrl} alt={'logo'} />
                                )}
                                <MenuOutlined onClick={() => { setIsOpen(!isOpen); props.getsize(!isOpen) }} />
                            </div>
                            : ""
                    }


                    {
                        !isOpen ?
                            <div className="menu-logo-close mb-4" >
                                <MenuOutlined className='close-menu' onClick={() => { setIsOpen(!isOpen); props.getsize(!isOpen) }} />
                            </div>
                            : ""
                    }

                    {menus.map((obj, index) => (
                        <div title={isOpen ? "" : obj.name} className={`menu-items ${obj.path === currentRoute ? "active" : ""}`} key={index} onClick={() => handleroute(obj)}>
                            {obj.iconComponent ? <div className='component-icon-div'>{obj.iconComponent}</div> : <div className='icon-div'>
                                <i className={obj.icon}></i>
                            </div>}
                            {
                                isOpen ?
                                    <div className='menu-text' >{obj.name}</div>
                                    : ""
                            }
                        </div>
                    ))}
                    {/* <div className='' onClick={() => navigate('/login')}>logout</div> */}
                </div>

                :

                <div className='bottom-nav'>
                    {mobilemenus.map((obj, index) => (
                        <div className={`menu-items ${obj.path === currentRoute ? "active" : ""}`} key={index} onClick={() => handleroute(obj)}>
                            <div className='icon-div'>
                                <i className={obj.icon}></i>
                            </div>
                            {/* <div className='menu-text' >{obj.name}</div> */}
                        </div>
                    ))}
                </div>
            }

        </>
    )
}
